<template>
    <div :class="compCssClasses">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "VContainer",
        props: {
            padding: {
                type: Boolean,
                default: true
            },
            bg: {
                type: String,
                required: true,
                validator(val){
                    val = val.toLowerCase();
                    const permittedValues = ['l', 'y', 'f', 'b', 'db'];
                    const isValid = (permittedValues.indexOf(val) != -1) ? true : false;
                    return isValid;
                }
            }
        },
        computed: {
            compCssClasses: function(){
                return [
                    this.bg,
                    {
                        p: this.padding,
                    }
                ]
            }
        }
        
    }
</script>

<style>
    .p{ padding: 30px 20px; }
    .f{ background-color: #f4f4f4; }
    .l{ background-color: #ffffff; }
    .b{ background-color: #113759; }
    .y{ background: #facb0a; }
    .db{ background: #021759; }
</style>